import * as actionTypes from '../actionTypes';

const state = {
  totalPoint: null,
  checkInQuota: null,
  isLoadingPostContentToGetRealCost: false,
  postContentToGetRealCostMessage: '',
  postContentToGetRealCostFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function pointReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
        totalPoint: globalState.totalPoint,
      };
    case actionTypes.SET_TOTAL_POINT:
      return {
        ...globalState,
        totalPoint: action.data,
      };
    case actionTypes.SET_CHECKIN_QUOTA:
      return {
        ...globalState,
        checkInQuota: action.data,
      };
    case actionTypes.POST_CONTENT_TO_GET_REAL_COST_PENDING:
      return {
        ...globalState,
        isLoadingPostContentToGetRealCost: true,
      };
    case actionTypes.POST_CONTENT_TO_GET_REAL_COST_FULFILLED:
      return {
        ...globalState,
        isLoadingPostContentToGetRealCost: false,
        postContentToGetRealCostMessage: action.data,
        postContentToGetRealCostFailed: '',
      };
    case actionTypes.POST_CONTENT_TO_GET_REAL_COST_FAILURE:
      return {
        ...globalState,
        isLoadingPostContentToGetRealCost: false,
        postContentToGetRealCostMessage: '',
        postContentToGetRealCostFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { pointReducer as default };
